import React from 'react'

import VideoPallet from '../../../../utils/VideoPallet'

function FirstSection() {
  return (
   <div className="min-h-screen relative flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute w-full h-full object-cover aspect-[3/4] sm:aspect-video md:aspect-video"
      >
        <source src={VideoPallet.thirdHeroVideo} type="video/mp4" />
        {/* Fallback message */}
        Your browser does not support the video tag.
      </video>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70" />
      
      {/* Main content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="relative h-72 flex justify-center items-center mt-20">
          <div className="text-center animate-bounce">
            <h1 className="text-5xl md:text-6xl font-black mb-2 transition-colors duration-300 hover:cursor-pointer capitalize">
              Tentukan Servis Apa yang anda inginkan
            </h1>
            <h2 className="text-5xl md:text-6xl font-black transition-colors duration-300 hover:cursor-pointer capitalize">
              Hanya Di Papakilo
            </h2>
          </div>
        </div>
      </div>

      <style>{`
        h1, h2 {
          background: linear-gradient(
            to bottom,
            #A75B3B 0%,
            #ffffff 50%,
            #ffffff 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          letter-spacing: 0.05em;
          font-family: "Arial Black", sans-serif;
        }

        h1:hover, h2:hover {
          background: linear-gradient(
            to bottom,
            #ffffff 0%,
            #ffd700 50%,
            #daa520 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 1.5s ease-out forwards;
        }

        video::-webkit-media-controls {
          display: none;
        }
      `}</style>
    </div>
  )
}

export default FirstSection